// @ngInject
function MockImportFileRowService(toastr, $timeout, $q) {
    return {
        validateFileRow: validateFileRow
    };

    function validateFileRow(fileRow) {
        var deferred = $q.defer();
        var returnList = [];

        var promise = $timeout(function() {
            if (fileRow.alternativeArticleNumber === '') {
                returnList.push({ severity:'error', property: 'AlternativeArticleNumber', errorType: 'NoValueAlternativeArticleNumber', displayMessage: 'importerror.wrongarticlenumber' });
            }

            if (fileRow.articleName === '') {
                returnList.push({ severity:'warning', property: 'articleName', errorType: 'NoValueArticleName', displayMessage: 'importerror.noarticlename' });
            }

            if (fileRow.descriptionShort) {
                returnList.push({ severity: 'warning', property: 'descriptionShort', errorType: 'NoValueDescriptionShort', displayMessage: 'importerror.nodescription' });
            }

            if (fileRow.itemGroupString === '') {
                returnList.push({ severity: 'error', property: 'ItemGroupString', errorType: 'NoValueItemGroup', displayMessage: 'importerror.nonexistentitemgroup' });
            }

            if (fileRow.variant1Name === '') {
                returnList.push({ severity:'error', property: 'variant1Name', errorType: 'NoValueVariant1Name', displayMessage: 'importerror.nonexistentcolor' });
            }

            if (fileRow.variant2Name === '') {
                returnList.push({ severity:'error', property: 'variant2Name', errorType: 'NoValueVariant2Name', displayMessage: 'importerror.nonexistentsize' });
            }

            if (fileRow.departmentCode === '') {
                returnList.push({ severity:'warning', property: 'departmentCode', errorType: 'NoValueDepartmentCode', displayMessage: 'importerror.nonexistent' });
            }

            if (fileRow.quantity === '') {
                returnList.push({ severity: 'warning', property: 'Quantity', errorType: 'NoValueQuantity', displayMessage: 'importerror.noquantity' });
            }

            if (fileRow.purchaseCost === '') {
                returnList.push({ severity: 'error', property: 'purchaseCost', errorType: 'NoValuePurchaseCost', displayMessage: 'importerror.nopurchasecost' });
            }

            if (fileRow.salesPrice === '') {
                returnList.push({ severity: 'error', property: 'salesPrice', errorType: 'NoValueSalesPrice', displayMessage: 'importerror.nosalesprice' });
            }

            if (fileRow.previousPrice === '') {
                returnList.push({ severity: 'warning', property: 'previousPrice', errorType: 'NoValuePreviousPrice', displayMessage: 'importerror.nopreviousprice' });
            }

            if (fileRow.subCategory === '') {
                returnList.push({ severity: 'warning', property: 'subCategory', errorType: 'NoValueSubcategory', displayMessage: 'importerror.nosubcategory' });
            }

            if (fileRow.intrastatCode === '') {
                returnList.push({ severity: 'warning', property: 'intrastatCode', errorType: 'NoValueIntrastatcode', displayMessage: 'importerror.nointrastatcode' });
            }

            if (fileRow.barcode === '') {
                returnList.push({ severity: 'error', property: 'barcode', errorType: 'NoValueBarcode', displayMessage: 'importerror.nobarcode' });
            }

            if (fileRow.collection === '') {
                returnList.push({ severity: 'warning', property: 'collection', errorType: 'NoValueCollection', displayMessage: 'importerror.nocollection' });
            }

            deferred.resolve(returnList);
        }, 2000);

        return deferred.promise;
    }

}


angular
    .module('services.mockImportFileRowService', [])
    .factory('MockImportFileRowService', MockImportFileRowService);
